<template>
    <div>
        <el-tabs v-model="activeName"  type="border-card">
<!--            <el-tab-pane label="周笔记榜单" name="0">-->
<!--                榜单:<cooperateBank :sectionClassId="3"></cooperateBank>-->
<!--                对我点赞:<cooperateLike :sectionClassId="3"></cooperateLike>-->
<!--                感谢我:<cooperateThanks :sectionClassId="3"></cooperateThanks>-->
<!--                需要我帮助:<cooperateCall :sectionClassId="3"></cooperateCall>-->
<!--                回复我:<cooperateCallback :sectionClassId="3"></cooperateCallback>-->
<!--            </el-tab-pane>-->
            <el-tab-pane label="周笔记" name="0">
                <cooperateForm :sectionClassId="3"></cooperateForm>
            </el-tab-pane>
            <el-tab-pane label="周事周毕红榜" name="1">
                <weekEndFormRed :sectionClassId="3"></weekEndFormRed>
            </el-tab-pane>
            <el-tab-pane label="周事周毕黑榜" name="2">
                <weekEndForm :sectionClassId="3"></weekEndForm>
            </el-tab-pane>


        </el-tabs>
    </div>
</template>

<script>
    //导入 HTTP请求方法
    import cooperateForm from '@/components/cooperative/cooperativeForm'
    import cooperateBank from '@/components/cooperative/cooperativeBank'
    import cooperateCall from '@/components/cooperative/cooperativeCall'
    import cooperateCallback from '@/components/cooperative/cooperativeCallback'
    import cooperateLike from '@/components/cooperative/cooperativeLike'
    import cooperateThanks from '@/components/cooperative/cooperativeThanks'
    import weekEndFormRed from "@/components/cooperative/weekEndFormRed"
    import weekEndForm from "@/components/cooperative/weekEndForm";
    //定义组件
    export default {
        data() {
            return {
                activeName:'0',
                activeName1:'0'
            }
        },
        components:{
            cooperateForm,
            cooperateBank,
            cooperateCall,
            cooperateCallback,
            cooperateThanks,
            cooperateLike,
            weekEndForm,
            weekEndFormRed

        }
    }
</script>


// WEBPACK FOOTER //
// src/views/cooperative/cooperate.vue